import { isEqual } from "lodash";
import { createDirtyChecker } from "../gvc/testNewForm/createDirtyChecker";
import { inputToIpSet } from "./utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToIpSet, (initItem, currItem, initRaw, currRaw) => {
    const dirty: Record<string, boolean> = {};
    if (!isEqual(initItem.description, currItem.description)) dirty.description = true;
    if (!isEqual(initItem.spec?.locations, currItem.spec?.locations)) dirty.locations = true;
    if (!isEqual(initItem.tags, currItem.tags)) dirty.tags = true;
    // Form-level: target discriminator and individual links
    if (initRaw.target !== currRaw.target) dirty.target = true;
    if (initRaw.target === "gvc" && initRaw.gvc.link !== currRaw.gvc.link) dirty.gvc = true;
    if (initRaw.target === "workload" && initRaw.workload.link !== currRaw.workload.link) dirty.workload = true;
    return dirty;
  });
}
